import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Error } from './Error';
import { TooltipIcon } from './TooltipIcon';
import { Label } from './Label';
import { theme } from '../../../theme/theme';
import { notUndefinedNull } from '../../../helpers/shared';
import { StyledGroup } from '../Input/styled';
import CurrencyInput from 'react-currency-input-field';
import { useSwitchDesign } from '../../../hooks/useSwitchDesign';
import { Required } from '../Input/styled';

const { first } = theme;

export const CustomMoneyInput = styled(CurrencyInput)`
  width: 100%;
  padding: .375rem .75rem;
  border-radius: .5rem;
  border: 1px solid #C4C4C4;
  background: #fff;
  color: #212529;
  outline: none;

  ${({$isNewDesign}) => $isNewDesign && css`
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.38);
    color: #fff;

    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }

    &:hover {
      background: rgba(255, 255, 255, 0.28) !important; 
    }

    &:disabled::placeholder {
      color: black;
    }
    &:disabled {
      background-color: rgba(30, 20, 50, 0.4);     
    }
    &:disabled:hover {
      background-color: rgba(30, 20, 50, 0.4) !important;     
    }
  `}

  &:focus {
    border-color: ${first};
    box-shadow: none;
  }
`;

/**
 * Input Currency component
 * @component
 * @param {Object} field
 * @param {Boolean} isRequiredInput
 * @param {String} label
 * @param {String} message
 * @param {String} name
 * @param {Function} onChange
 * @param {String} placeholder
 * @param {Function} register
 * @param {String} tooltipText
 * @returns
 */
export const CurrencyMoneyInput = ({
  field,
  isRequiredInput,
  label,
  message,
  name,
  onChange,
  placeholder,
  register,
  tooltipText,
  disabled,
  value,
  defaultValue,
  isNewDesign
}) => {
  let cleanDefaultValue = defaultValue?.replace(/\D/g, '')
  const { altErrorStyle } = useSwitchDesign()

  return (
    <StyledGroup className="mb-3">
      <Label htmlFor={ name } isNewDesign={isNewDesign}>
        { label }{ isRequiredInput && (
          <Required className="text-danger">&nbsp;*</Required>)}{ tooltipText && (
          <TooltipIcon 
            tooltipText={ tooltipText } 
            color={isNewDesign && third}
          />)}
      </Label>
      <CustomMoneyInput
        { ...register(name) }
        allowDecimals={false}
        autoComplete="off"
        data-action={ field?.action }
        data-category={ `category-${field?.category?.field_category}` }
        data-condition={ field?.parent_condition }
        data-parent={ field?.parent }
        data-unique-name={ name }
        decimalSeparator={(field && field?.mask)
          ? JSON.parse(field?.mask)?.decimal : "."}
        decimalsLimit={0}
        defaultValue={  Number(cleanDefaultValue) || field?.defaultValue }
        groupSeparator={(field && field?.mask)
          ? JSON.parse(field?.mask)?.group : ","}
        id={ field?.id }
        key={ field?.id }
        maxLength={(notUndefinedNull(
          field?.max_length)) ? field.max_length.toString() : ''}
        name={ name }
        onChange={ onChange }
        value={Number(value) ?? Number(cleanDefaultValue) ?? field?.defaultValue ?? ''}
        placeholder={ placeholder }
        intlConfig={{ locale: 'en-US' }}
        disabled={disabled}
        $isNewDesign={isNewDesign}
      />
      {message && (
        <Error 
          message={ message }
          altErrorMessageStyle={altErrorStyle}
        />
      )}
    </StyledGroup>
  );
};

CurrencyInput.propTypes = {
  field: PropTypes.object,
  isRequiredInput: PropTypes.bool,
  label: PropTypes.string,
  message: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  register: PropTypes.func,
  tooltipText: PropTypes.string,
  disabled: PropTypes.bool
};